import { apiClient } from '../client';
import { AxiosError } from 'axios';
import { User } from '@/contexts/AppContext';

export interface Verify2FAResponse {
  success: boolean;
  requiresTwoFactor?: boolean;
  token?: string;
  refreshToken?: string;
  sessionId?: string;
  user?: User;
  data?: {
    user?: User;
  };
  message?: string;
  error?: string;
}

export interface Verify2FARequest {
  verificationToken: string;
  code: string;
}

export const verify2fa = async (data: Verify2FARequest, role?: string): Promise<Verify2FAResponse> => {
  try {
    const endpoint = role === 'operator' ? '/auth/operator/login/verify-2fa' : '/auth/login/verify-2fa';
    const response = await apiClient.post<Verify2FAResponse>(endpoint, data);
    
    if (response.data.success && !response.data.requiresTwoFactor) {
      // Identity ADR: tokens are never stored in localStorage (XSS → permanent
      // takeover). The session is carried by the HttpOnly cookie set by the
      // backend; we keep only a non-sensitive user hint for UI bootstrap.
      localStorage.setItem('sessionId', response.data.sessionId || '');
      localStorage.setItem('user', JSON.stringify(response.data.user || response.data.data?.user));
    }
    
    return response.data;
  } catch (error: unknown) {
    if (error instanceof AxiosError) {
      const errorData = error.response?.data || { success: false, message: 'Verification failed' };
      throw new Error(errorData.error || errorData.message || 'Verification failed');
    }
    throw new Error(error instanceof Error ? error.message : 'Verification failed');
  }
};
